import axios from 'axios'

const axios_zendesk = axios.create()

export default axios_zendesk